import DisplayObject = createjs.DisplayObject;
import {TableHeadButton} from "@goodgamestudios/poker2-createjs-assets";


export class TableHeadButtonHelper {
    public static setHeadButtonsSizes(sizes: number[], container: DisplayObject) {
        for (var i: number = 0; i < sizes.length; i++) {
            var tableHead: TableHeadButton = container["sort_" + i] as TableHeadButton;
            tableHead.setBgScaleX(sizes[i]);
        }
    }
}